import Graphic from "@arcgis/core/Graphic";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol";

type GeometryType =
  | "extent"
  | "point"
  | "multipoint"
  | "polyline"
  | "polygon"
  | "mesh";
type Usage = "sketch" | "draw" | "turbo" | "highligh";

export const DrawSymbol = (
  geometryType: GeometryType,
  usage: Usage = "sketch"
) => {
  switch (geometryType) {
    case "point":
      if (usage === "sketch") {
        return pointSymbol;
      } else if (usage === "highligh") {
        return selectPointSymbol;
      } else {
        return pointSymbol;
      }
    case "polyline":
      if (usage === "sketch") {
        return lineSymbol;
      } else if (usage === "highligh") {
        return selectLineSymbol;
      } else {
        return lineSymbol;
      }

    case "polygon":
      if (usage === "sketch") {
        return polygonSymbol;
      } else if (usage === "highligh") {
        return selectPolygonSymbol;
      } else {
        return polygonSymbol;
      }

    default:
      return pointSymbol;
  }
};

export const AddStyle = (graphic: Graphic, usage: Usage) => {
  return DrawSymbol(graphic.geometry.type as GeometryType, usage);
};

export const selectPointSymbol = new SimpleMarkerSymbol({
  color: [0, 255, 255],
  outline: {
    color: [0, 200, 255],
    width: 2,
  },
  size: 7,
});

export const pointSymbol = new SimpleMarkerSymbol({
  color: [0, 0, 255],
  outline: {
    color: [255, 255, 255],
    width: 2,
  },
  size: 7,
});

const lineSymbol = new SimpleLineSymbol({
  cap: "round",
  color: [0, 122, 194, 1],
  join: "round",
  miterLimit: 1,
  style: "solid",
  width: 1,
});

const selectLineSymbol = new SimpleLineSymbol({
  cap: "round",
  color: [0, 255, 255],
  join: "round",
  miterLimit: 1,
  style: "solid",
  width: 1,
});

const polygonSymbol = new SimpleFillSymbol({
  color: [0, 122, 194, 1],
  outline: new SimpleLineSymbol({
    cap: "round",
    color: [0, 122, 194, 1],
    join: "round",
    miterLimit: 1,
    style: "solid",
    width: 1,
  }),
  style: "forward-diagonal",
});

const selectPolygonSymbol = new SimpleFillSymbol({
  color: [0, 255, 255],
  outline: new SimpleLineSymbol({
    cap: "round",
    color: [0, 200, 255],
    join: "round",
    miterLimit: 1,
    style: "solid",
    width: 1,
  }),
  style: "forward-diagonal",
});
